import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Box from '@mui/material/Box'
import CssBaseline from '@mui/material/CssBaseline'
import Divider from '@mui/material/Divider'
import Drawer from '@mui/material/Drawer'
import List from '@mui/material/List'
import Toolbar from '@mui/material/Toolbar'
import Logo from '../../assets/images/logo_text.png'
import Item from './partials/MenuItem'
import { useStyles } from '../styles'
import { Content } from '../Content'
import { useDataProvider } from 'react-admin'
import { MenuItem, Select } from '@material-ui/core'
import { Alert } from '../Content/partials'
import jwt from 'jwt-decode'

import HsHeaderBar from './partials/HsHeaderBar'
import { DRAWER_WIDTH } from './constants'
import config from '../../config'

function Menus({
  coproprietaire,
  copro,
  coproprietaires,
  setCoproprietaire,
  setCopro,
  ...props
}) {
  const publicUrl = config.PUBLIC_URL
  let interventionItem = {
    id: 'Interventions',
    label: 'Actions de la copro',
    title: 'Interventions de ma copropriété',
    description:
      'Sur cette page, je peux suivre toutes les demandes et les interventions de ma copropriété.',
  }

  // FIXME : need to check somewhere else users roles
  const hasRoleCSMember =
    (coproprietaire &&
      coproprietaire.copro &&
      jwt(localStorage.getItem('auth')).roles.some(
        (role) =>
          role.roles.includes('CSMember') &&
          role.coproCopromaticId == coproprietaire.copro.id
      )) ||
    false

  const items = [
    {
      id: 'Accueil',
      label: 'Accueil',
      title: 'Mon Tableau de bord',
      icon: `${publicUrl + `/img/icons/icon-dashboard-color.svg`}`,
      description:
        'Sur cette page, je vois les derniers évènements de ma copropriété',
      nestedItems: [],
    },
    {
      id: 'Les demandes',
      label: 'Les demandes',
      tooltip: 'Tout ce qui concerne les interventions dans ma copropriété',
      icon: `${publicUrl + `/img/icons/icon-paint-color.svg`}`,
      nestedItems: [
        {
          id: 'Demander une intervention',
          label: 'Demander une intervention',
          title: 'Demander une intervention',
          description:
            'Sur cette page, je peux suivre toutes les demandes et les interventions de ma copropriété.',
          toItem: interventionItem,
        },
        interventionItem,
        {
          id: 'Mises en concurrence',
          label: 'Mises en concurrence',
          title: 'Mises en concurrence',
          description:
            'Sur cette page, je peux suivre toutes les mises en concurrence de ma copropriété.',
        },
        {
          id: 'Sinistre',
          label: 'Sinistres',
          title: 'Gestion des sinistres de ma copropriété',
          description: 'Sur cette page, je peux suivre mes sinistres ',
          disabled: true,
        },
        // {
        //   id: 'Mes demandes',
        //   label: 'Mes demandes',
        // },
      ],
    },
    {
      id: 'Administratif',
      label: 'Administratif',
      tooltip: 'La gestion et les informations de ma copropriété',
      icon: `${publicUrl + `/img/icons/icon-door-color.svg`}`,
      nestedItems: [
        {
          id: 'Informations & Documents',
          label: 'Informations',
          title: 'Informations de ma copropriété',
          description:
            'Cette page comprend les différentes informations de ma copropriété',
        },
        {
          id: 'Mes documents',
          label: 'Mes documents',
          title: 'Mes documents',
          description:
            'Sur cette page, je peux voir tous les documents de ma copropriété',
        },
      ],
    },
    {
      id: 'Assemblées générales',
      label: 'Assemblées générales',
      title: 'Assemblées générales',
      description:
        'Sur cette page, je peux suivre les assemblées générales à venir, mes convocations et les PV des anciennes assemblées générales.',
      nestedItems: [],
      icon: `${publicUrl + `/img/icons/icon-documents-color.svg`}`,
    },
    {
      id: 'Mes Finances',
      label: 'Mes Finances',
      tooltip: 'Votre gestion financière et celle de votre copropriété',
      icon: `${publicUrl + `/img/icons/icon-money-color.svg`}`,
      nestedItems: [
        {
          id: 'Questions comptables',
          label: 'Questions Comptables',
          title: 'Mes demandes comptables',
          description:
            'Sur cette page, je peux voir toutes mes demandes concernant ma comptabilité',
        },
        {
          id: 'Mon dernier appel de fonds',
          label: 'Dernier appel de fonds',
          title: 'Mon dernier appel de fonds',
          description:
            'Sur cette page, je peux voir mon dernier appel de fonds.',
        },
        {
          id: 'Tous mes appels de fonds',
          label: 'Tous mes appels de fonds',
          title: 'Mes appels de fonds',
          description: 'Sur cette page, je peux voir tous mes appels de fonds.',
        },
        {
          id: 'Suivi des factures copro',
          label: 'Suivi des factures',
          title: 'Factures',
          description:
            'Sur cette page, je peux suivre les différentes factures de ma copropriété',
        },
        {
          id: 'RGDD',
          label: 'RGDD',
          title: 'RGDD',
          description:
            'Sur cette page, je peux suivre le Relevé Général des Dépenses de ma copropriété',
          hide: !hasRoleCSMember,
        },
        {
          id: 'Prélèvement automatique',
          label: 'Prélèvements automatiques(Mandat SEPA)',
          title: 'Prélèvement SEPA',
          description:
            'Sur cette page, je peux suivre les différentes factures de ma copropriété',
          toUrl:
            'https://forms.monday.com/forms/be82cd61a4a89a7ad35abd0a54803c7b?r=use1',
        },
        {
          id: 'Compte Bancaire',
          label: 'Compte Bancaire',
          title: 'Compte Bancaire',
          description:
            "Sur cette page, je peux suivre l'historique des 6 derniers mois des comptes de la copropriété",
          hide: !hasRoleCSMember,
        },
        {
          id: 'Budget',
          label: 'Budget prévisionnel',
          title: 'Budget prévisionnel',
          description: 'Sur cette page, je peux suivre mes différents budgets',
          hide: !hasRoleCSMember,
        },
        // {
        //   id: 'Historique comptable',
        //   label: 'Historique comptable',
        //   disabled: true,
        // },
        // {
        //   id: 'Comptabilité copropriété',
        //   label: 'Comptabilité copropriété',
        //   disabled: true,
        // },
      ],
    },
  ]
  const itemsPreferecens = [
    {
      id: 'Conciergerie personnelle',
      label: 'Conciergerie',
      tooltip: 'Vos demandes de services ',
      icon: `${publicUrl + `/img/icons/icon-tickets-color.svg`}`,
      nestedItems: [
        {
          id: 'Demander un nouveau Bip',
          label: 'Demander un nouveau Bip',
        },
        {
          id: 'Mes travaux',
          label: 'Mes travaux',
        },
        {
          id: 'Mettre en location',
          label: 'Mettre en location',
        },
        {
          id: 'Assurance habitation en 2 mn',
          label: 'Assurance habitation en 2 mn',
          toUrl: config.APP_LOVYS,
        },
        {
          id: 'Mettre en vente',
          label: 'Mettre en vente',
        },
        // {
        //   id: 'Me rappeler !',
        //   label: 'Me rappeler !',
        //   disabled: true,
        // },
        // {
        //   id: 'Faire une surprise dans la copro',
        //   label: 'Faire une surprise dans la copro',
        //   disabled: true,
        // },
      ],
    },
    {
      id: 'Mes préférences',
      label: 'Préférences',
      title: 'Mes préférences',
      icon: `${publicUrl + `/img/icons/icon-run-color.svg`}`,
      description:
        'Sur cette page, je peux modifier mes préférences de contact.',
      nestedItems: [],
    },
    {
      id: 'Extranet détaillé',
      label: 'Extranet détaillé',
      icon: 'Default',
      toUrl: `${config.COPROMATIC_EXTRANET}/${copro?.id}/${coproprietaire?.id}`,
      nestedItems: [],
    },
    {
      id: 'Déconnexion',
      label: 'Déconnexion',
      icon: `${publicUrl + `/img/icons/logout.png`}`,
      nestedItems: [],
    },
  ]
  const { window } = props
  const [mobileOpen, setMobileOpen] = useState(false)
  const [selectedItem, setSelectedItem] = useState({
    id: 'Accueil',
    label: 'Accueil',
    description:
      'Sur cette page, je vois les derniers évènements de ma copropriété',
    title: 'Mon Tableau de bord',
  })
  const classes = useStyles()
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }
  const [loaded, setLoaded] = useState(false)
  const dataProvider = useDataProvider()
  const handleChange = (event) => {
    setCoproprietaire(event.target.value)
    dataProvider
      .getOne('ext_copros', { id: event.target.value.copro.id })
      .then(({ data }) => {
        setCopro(data)
        setLoaded(true)
      })
      .catch((error) => {})
  }

  const loadCoproprietaire = (coproprietaires) => {
    if (coproprietaires.length && !coproprietaire) {
      dataProvider
        .getOne('ext_copros', { id: coproprietaires[0].copro.id })
        .then(({ data }) => {
          setCoproprietaire(coproprietaires[0])
          setCopro(data)
          setLoaded(true)
        })
        .catch((error) => {})
    }
  }
  useEffect(() => {
    loadCoproprietaire(coproprietaires)
  }, [coproprietaires])
  const drawer = (
    <div>
      <Toolbar sx={{ padding: '0 !important' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            marginTop: '10px',
            flexDirection: 'column',
            rowGap: '10px',
          }}
        >
          <Box>
            <img
              src={Logo}
              className={classes.logo}
              onClick={() => {
                setSelectedItem({
                  id: 'Dashboard',
                })
              }}
            />
          </Box>
          {coproprietaires.length > 1 && (
            <Select
              fullWidth
              variant="outlined"
              value={coproprietaire}
              onChange={handleChange}
            >
              {coproprietaires.map((co) => (
                <MenuItem
                  value={co.id == coproprietaire?.id ? coproprietaire : co}
                >
                  {co.libelle} - {co.copro.libelle}
                </MenuItem>
              ))}
            </Select>
          )}
        </Box>
      </Toolbar>
      <Divider />
      <List>
        {items.map((item) => (
          <Item
            item={item}
            handleDrawerToggle={handleDrawerToggle}
            selectedItem={selectedItem}
            setSelectedItem={setSelectedItem}
            coproprietaire={coproprietaire}
          />
        ))}
      </List>
      <Divider />
      <List>
        {itemsPreferecens.map((item) => (
          <Item
            item={item}
            handleDrawerToggle={handleDrawerToggle}
            selectedItem={selectedItem}
            setSelectedItem={setSelectedItem}
          />
        ))}
      </List>
    </div>
  )

  const container =
    window !== undefined ? () => window().document.body : undefined

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />

      <HsHeaderBar
        coproprietaire={coproprietaire}
        handleDrawerToggle={handleDrawerToggle}
        headerBarTitle={selectedItem.title}
      />

      {loaded == false ? (
        <div />
      ) : (
        <>
          <Box
            component="nav"
            sx={{ width: { lg: DRAWER_WIDTH }, flexShrink: { lg: 0 } }}
            aria-label="mailbox folders"
          >
            {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
            <Drawer
              container={container}
              variant="temporary"
              open={mobileOpen}
              onClose={handleDrawerToggle}
              ModalProps={{
                keepMounted: true, // Better open performance on mobile.
              }}
              sx={{
                display: { xs: 'block', lg: 'none' },
                '& .MuiDrawer-paper': {
                  boxSizing: 'border-box',
                  width: DRAWER_WIDTH,
                },
              }}
            >
              {drawer}
            </Drawer>
            <Drawer
              variant="permanent"
              sx={{
                display: { xs: 'none', lg: 'block' },
                '& .MuiDrawer-paper': {
                  boxSizing: 'border-box',
                  width: DRAWER_WIDTH,
                },
              }}
              open
            >
              {drawer}
            </Drawer>
          </Box>
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              p: 3,
              maxWidth: { lg: '70%' },
              margin: '0 auto',
              overflow: 'auto',
            }}
          >
            {/* <Toolbar /> */}
            <Alert
              copro={copro}
              coproprietaire={coproprietaire}
              selectedItem={selectedItem}
              sx={{ xs: 'none', md: 'block' }}
            />
            <Content
              copro={copro}
              coproprietaire={coproprietaire}
              selectedItem={selectedItem}
            />
          </Box>
        </>
      )}
    </Box>
  )
}

Menus.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
}

export default Menus
